import { render, staticRenderFns } from "./BookingConfirmationCommon.vue?vue&type=template&id=3d922bc3&"
import script from "./BookingConfirmationCommon.vue?vue&type=script&lang=js&"
export * from "./BookingConfirmationCommon.vue?vue&type=script&lang=js&"
import style0 from "./BookingConfirmationCommon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d922bc3')) {
      api.createRecord('3d922bc3', component.options)
    } else {
      api.reload('3d922bc3', component.options)
    }
    module.hot.accept("./BookingConfirmationCommon.vue?vue&type=template&id=3d922bc3&", function () {
      api.rerender('3d922bc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/BookingConfirmationCommon.vue"
export default component.exports